import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { createInvitationToTeam, getOwnerInvitees, getPlayerInvitees } from "../services/teamsService";
import { acceptInvitation, getMyInvitations, rejectInvitation } from "../services/notificationsService";
import { toast } from "react-toastify";

interface InvitationState {
  ownerInvitees: any[];
  playerInvitees: any[];
  isBusy: boolean;
  busyMessage: string;
  createInviteResult: string;
  myInvitations: any[];
  fetchOwnerInvitees: (seasonId: string, teamId: string) => Promise<void>;
  fetchPlayerInvitees: (seasonId: string, teamId: string) => Promise<void>;
  createInvite: (seasonId: string, teamId: string, id: string, role: string) => Promise<void>;
  fetchMyInvitations: (seasonId: string) => Promise<void>;
  acceptUserInvitation: (seasonId: string, invitationId: string) => Promise<void>;
  rejectUserInvitation: (seasonId: string, invitationId: string) => Promise<void>;
}

const useInvitationStore = create<InvitationState>()(
  devtools(
    (set, get) => ({
      ownerInvitees: [],
      playerInvitees: [],
      isBusy: false,
      busyMessage: "",
      createInviteResult: '',
      myInvitations: [],
      fetchOwnerInvitees: async (seasonId: string, teamId: string) => {
        set({ isBusy: true, busyMessage: "Fetching owner invitees..." });
        try {
          const response = await getOwnerInvitees(seasonId, teamId);
          if (response && response.code === 9012) {
            const data = response.result;
            set({ ownerInvitees: data });
          } else {
            toast.error(response.message)
          }
        } finally {
          set({ isBusy: false, busyMessage: "" });
        }
      },
      fetchPlayerInvitees: async (seasonId: string, teamId: string) => {
        set({ isBusy: true, busyMessage: "Fetching player invitees..." });
        try {
          const response = await getPlayerInvitees(seasonId, teamId);
          if (response && response.code === 9013) {
            const data = response.result;
            set({ playerInvitees: data });
          } else {
            toast.error(response.message)
          }
        } finally {
          set({ isBusy: false, busyMessage: "" });
        }
      },
      createInvite: async (seasonId: string, teamId: string, id: string, role: string) => {
        set({ isBusy: true, busyMessage: "Creating invite..." });
        try {
          const response = await createInvitationToTeam(seasonId, teamId, id, role);
          if (response && response.code === 9055) {
           
          }else {
            toast.error(response.message);
          }
        } finally {
          set({ isBusy: false, busyMessage: "" });
        }
      },
      fetchMyInvitations: async (seasonId: string) => {
        set({ isBusy: true, busyMessage: "Fetching my invitations...", myInvitations: [] });
        try {
          const response = await getMyInvitations(seasonId);
          if (response && response.code === 9019) {
            const data = response.result;
            set({ myInvitations: data });
          }
        } finally {
          set({ isBusy: false, busyMessage: "" });
        }
      },
      acceptUserInvitation: async (seasonId: string, invitationId: string) => {
        set({ isBusy: true, busyMessage: "Accepting invitation..." });
        try {
          const response = await acceptInvitation(invitationId);
          if (response && response.code === 9017) {
            get().fetchMyInvitations(seasonId);
          } else {
            // notify failure.
          }
        } finally {
          set({ isBusy: false, busyMessage: "" });
        }
      },
      rejectUserInvitation: async (seasonId: string, invitationId: string) => {
        set({ isBusy: true, busyMessage: "Rejecting invitation..." });
        try {
          const response = await rejectInvitation(invitationId);
          if (response && response.code === 9031) {
            get().fetchMyInvitations(seasonId);
          } else {
            // notify failure.
          }
        } finally {
          set({ isBusy: false, busyMessage: "" });
        }
      }
    }),
    {
      name: "invitationsStore",
      enabled: process.env.NODE_ENV === "development",
    }
  )
);

export default useInvitationStore;
